"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AddItemIcon = void 0;

var _react = _interopRequireDefault(require("react"));

var _helpers = require("../helpers");

var _Icon = require("./Icon");

var _excluded = ["title"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/** AddItemIcon */
var AddItemIcon = function AddItemIcon(_ref) {
  var _ref$title = _ref.title,
      title = _ref$title === void 0 ? "Submit your artwork" : _ref$title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/_react.default.createElement(_Icon.Icon, _extends({}, props, {
    viewBox: "0 0 125 161"
  }), /*#__PURE__*/_react.default.createElement(_Icon.Title, null, title), /*#__PURE__*/_react.default.createElement(_Icon.Path, {
    fill: (0, _helpers.color)(props.fill),
    d: "M10.48 20.893a3.75 3.75 0 00-3.75 3.75v11.254h7.5v-7.504H24.24v-7.5H10.48zM58.631 20.893H31.115v7.5H58.63v-7.5zM93.024 20.893H65.507v7.5h27.517v-7.5zM113.658 20.893H99.9v7.5h10.008v7.504h7.5V24.643a3.75 3.75 0 00-3.75-3.75zM117.408 64.03V41.52h-7.5V64.03h7.5zM6.73 41.521V64.03h7.5V41.522h-7.5zM6.73 69.654v22.508h7.5V69.654h-7.5zM117.408 92.162V69.654h-7.5v22.508h7.5zM6.73 97.787v22.508h7.5V97.787h-7.5zM117.408 120.295V97.787h-7.5v22.508h7.5zM117.408 137.174V125.92h-7.5v7.504H99.9v7.5h13.758a3.75 3.75 0 003.75-3.75zM6.73 125.92v11.254a3.75 3.75 0 003.75 3.75H24.24v-7.5H14.23v-7.504h-7.5zM31.115 140.924H58.63v-7.5H31.115v7.5zM65.507 140.924h27.517v-7.5H65.507v7.5zM62.48 56.643a4 4 0 014 4v16.444h16a4 4 0 010 8h-16v15.556a4 4 0 01-8 0V85.087h-16a4 4 0 110-8h16V60.643a4 4 0 014-4z"
  }));
};

exports.AddItemIcon = AddItemIcon;
AddItemIcon.displayName = "AddItemIcon";
//# sourceMappingURL=AddItemIcon.js.map